import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./ManageCards.css";

export default function ManageCards() {
  const [cards, setCards] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const navigate = useNavigate();

  useEffect(() => {
    const q = query(collection(db, "workCards"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const cardsData = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      const sorted = cardsData.sort(
        (a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)
      );

      setCards(sorted);
    });

    return () => unsubscribe();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this card?")) return;
    await deleteDoc(doc(db, "workCards", id));
  };

  const toggleActive = async (card) => {
    await updateDoc(doc(db, "workCards", card.id), {
      active: !card.active,
    });
  };

  const duplicateCard = async (card) => {
    const copy = { ...card };
    delete copy.id;

    await addDoc(collection(db, "workCards"), {
      ...copy,
      title: (copy.title || "Untitled") + " (Copy)",
      createdAt: serverTimestamp(),
      active: true,
    });
  };

  const filteredCards = cards.filter((card) => {
    const text = `${card.title || ""} ${card.description || ""}`.toLowerCase();
    const matchSearch = text.includes(search.toLowerCase());

    const isActive = card.active !== false;

    const matchFilter =
      filter === "all" ||
      (filter === "active" && isActive) ||
      (filter === "hidden" && !isActive);

    return matchSearch && matchFilter;
  });

  return (
    <div className="manage-cards-container">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ⬅ Back
      </button>

      <h1>Manage Work Cards</h1>

      <div className="manage-toolbar">
        <button onClick={() => navigate("/super-secret-add-card")}>
          ➕ Add New
        </button>

        <input
          type="text"
          placeholder="Search cards..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="hidden">Hidden</option>
        </select>
      </div>

      {filteredCards.length === 0 && <p>No cards found.</p>}

      <div className="cards-grid">
        {filteredCards.map((card) => (
          <div key={card.id} className="admin-card">
            <div className="status-badge">
              {card.active === false ? "🔴 Hidden" : "🟢 Active"}
            </div>

            <img
              src={card.image || "https://via.placeholder.com/400x250?text=No+Image"}
              alt={card.title || "No title"}
            />

            <h3>{card.title || "Untitled"}</h3>
            <p>{card.description || "No description"}</p>

            <div className="admin-actions">
              <button onClick={() => navigate(`/edit-card/${card.id}`)}>
                ✏️ Edit
              </button>

              <button onClick={() => toggleActive(card)}>
                {card.active === false ? "👁 Show" : "🙈 Hide"}
              </button>

              <button onClick={() => duplicateCard(card)}>📄 Duplicate</button>

              <button onClick={() => navigate(`/admin-preview/${card.id}`)}>
                🔍 Preview
              </button>

              <button className="danger" onClick={() => handleDelete(card.id)}>
                🗑 Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
